import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
    OnDestroy,
} from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { fuseAnimations } from "@fuse/animations";
import { debounceTime, distinctUntilChanged, takeUntil } from "rxjs/operators";

import { PersonaDTO } from "app/main/apps/shared/interfaces/persona.interface";
import { MatPaginator } from "@angular/material/paginator";
import { Subject, Subscription, fromEvent } from "rxjs";

@Component({
    selector: "app-tabla-encargados",
    templateUrl: "./tabla-encargados.component.html",
    styleUrls: ["./tabla-encargados.component.scss"],
    animations: fuseAnimations,
})
export class TablaEncargadosComponent implements OnInit, OnDestroy {
    @Input() encargados: PersonaDTO[];
    @Input() esRepresentante:boolean;
    @Input() esSupervisor:boolean;
    @Output() borrarEncargado: EventEmitter<any> = new EventEmitter();
    @Output() editarEncargado: EventEmitter<any> = new EventEmitter();

    dataSource: MatTableDataSource<any>;
    displayedColumns = [
        "rut",
        "nombre",
        "apellido",
        "cotizar",
        "comprar",
        "recibir"
    ];

    @ViewChild(MatPaginator, { static: true })
    paginator: MatPaginator;

    @ViewChild(MatSort, { static: true })
    sort: MatSort;

    @ViewChild("filter", { static: true })
    filter: ElementRef;

    private subscripciones: Subscription;
    private _unsubscribeAll: Subject<any>;
    constructor() {
        this.subscripciones = new Subscription();
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {

        if (this.esRepresentante || this.esSupervisor){
            this.displayedColumns.push('borrar');
        }

        this.dataSource = new MatTableDataSource(this.encargados);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.subscripciones.add(
            this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0))
        );

        fromEvent(this.filter.nativeElement, "keyup")
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(150),
                distinctUntilChanged()
            )
            .subscribe(() => {
                if (!this.dataSource) {
                    return;
                }

                this.dataSource.filter = this.filter.nativeElement.value;
            });
    }

    borrar(rutEncargado: number): void {
        this.borrarEncargado.emit(rutEncargado);
    }

    editar(sucursal) {
        this.editarEncargado.emit(sucursal);
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
